import { Component, inject, input } from '@angular/core';
import {ChipModule} from "primeng/chip";
import {DataService, WriterResourceMatchType} from "../../service/data.service";

import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {BetaReaderStatus, WriterStatus, ProjectMatchStatus} from "../../api/enums";
import {MessageService} from "primeng/api";

import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';
import { BetaReaderProject } from 'src/app/api/db/entities/BetaReaderProject';

@Component({
    selector: 'resource-detail',
    imports: [
    ChipModule,
    ButtonModule,
    RippleModule
],
    templateUrl: './resource-detail.component.html',
    styleUrl: './resource-detail.component.scss'
})
export class ResourceDetailComponent {
    private messageService = inject(MessageService);
    private dataService = inject(DataService);

    readonly resourceMatch = input.required<ProjectMatchType>();

    protected readonly Array = Array;

    protected decisionMade: boolean = false;

    isArray(value: string | string[]) {
        return value instanceof Array;
    }

    async setAccept() {
        const resourceMatch = this.resourceMatch();
        console.log('BetaReaderProject Save: ', resourceMatch.project);


        const tempBRP = new BetaReaderProject();
        tempBRP.id = null;
        tempBRP.lastInfoRead = null;
        tempBRP.betaReaderStatus = BetaReaderStatus.ACTIVE;
        tempBRP.writerStatus = WriterStatus.ACTIVE;
        tempBRP.betaReaderProfileId = resourceMatch.betaReader.id;
        tempBRP.betaReaderProfile = resourceMatch.betaReader;
        tempBRP.projectId = resourceMatch.project.id;
        tempBRP.project = resourceMatch.project;





        let result = await this.dataService.saveBetaReaderProject(tempBRP);
        if (result == "SUCCESS") {
            this.dataService.setProjectMatchTypeStatus(resourceMatch, ProjectMatchStatus.ACTIVE);
        }

        /*if (!resourceMatch.project.id) {
            await this.dataService.saveBetaReaderProject(tempBRP);
        }
        await this.dataService.setBetaReaderStatus(resourceMatch.project, BetaReaderStatus.ACTIVE);
        await this.dataService.setBRPWriterStatus(resourceMatch.project, WriterStatus.ACTIVE)
        resourceMatch.project.betaReaderStatus = BetaReaderStatus.ACTIVE;
        resourceMatch.project.writerStatus = WriterStatus.ACTIVE;*/


        this.messageService.add({ severity: 'info', summary: 'Beta Reader Accepted', detail: 'We\'ve notified the beta reader of their acceptance for this project.' });
        this.decisionMade = true;
    }

    async setNotInterested() {
        const resourceMatch = this.resourceMatch();
        console.log('ProjectMatchType Save For Project: ',resourceMatch.project);

        this.dataService.setProjectMatchTypeStatus(resourceMatch, ProjectMatchStatus.WRITER_REJECTED);

        /*if (!resourceMatch.project.id) {
            await this.dataService.saveBetaReaderProject(resourceMatch.project);
        }
        await this.dataService.setBetaReaderStatus(resourceMatch.project, null);
        await this.dataService.setBRPWriterStatus(resourceMatch.project, WriterStatus.NOT_INTERESTED)
        resourceMatch.project.betaReaderStatus = null;
        resourceMatch.project.writerStatus = WriterStatus.NOT_INTERESTED;*/

        this.messageService.add({ severity: 'info', summary: 'Beta Reader Status Updated', detail: 'We have registered "Not Interested"' });
        this.decisionMade = true;
    }

    protected readonly BetaReaderStatus = BetaReaderStatus;
    protected readonly ProjectMatchStatus = ProjectMatchStatus;
}
